import { API_URL } from "@config";
import { createHttpClient, createFetchTransport, createErrorPlugin, createErrorReporterPlugin } from "@kalodata/http";
import { reportHttpRequestError } from "./reportHttpEvent";
import { createAuthPlugin } from "./authPlugin";
import { createSlicePlugin } from "./slicePlugin";
import type { ClipHttpContext, ClipHttpMeta } from "./types";
import {
  createHttpRequestReportSuccessPlugin,
  createLegacyHeadersPlugin,
  createLegacyQueryPlugin,
  createToastErrorPlugin,
  DEFAULT_CLIP_TIMEOUT_MS,
  isBusinessError,
} from "./httpPlugins";

export const clipHttpClient = createHttpClient<ClipHttpMeta, ClipHttpContext>({
  baseUrl: API_URL,
  defaultTimeoutMs: DEFAULT_CLIP_TIMEOUT_MS,
  transport: createFetchTransport<ClipHttpMeta, ClipHttpContext>(),
  plugins: [
    createLegacyHeadersPlugin(),
    createLegacyQueryPlugin(),
    createAuthPlugin<ClipHttpMeta, ClipHttpContext>(),
    createErrorPlugin<ClipHttpMeta, ClipHttpContext>({
      isBusinessError,
    }),
    createSlicePlugin<ClipHttpMeta, ClipHttpContext>(),
    createHttpRequestReportSuccessPlugin(),
    createErrorReporterPlugin<ClipHttpMeta, ClipHttpContext>({
      reportError: (error, context) => {
        if (!error.request) {
          error.request = context.request;
        }
        reportHttpRequestError(error, context);
      },
    }),
    createToastErrorPlugin(),
  ],
});
